import { withQuery } from '../utils/queryString'
import { idParaRuta } from '../utils/idParaRuta'
import { CALL_API } from '../middleware/api'

export const CLAIM_LIST_REQUEST = 'CLAIM_LIST_REQUEST'
export const CLAIM_LIST_SUCCESS = 'CLAIM_LIST_SUCCESS'
export const CLAIM_LIST_FAILURE = 'CLAIM_LIST_FAILURE'

export const CLAIM_DETAIL_REQUEST = 'CLAIM_DETAIL_REQUEST'
export const CLAIM_DETAIL_SUCCESS = 'CLAIM_DETAIL_SUCCESS'
export const CLAIM_DETAIL_FAILURE = 'CLAIM_DETAIL_FAILURE'

export const CLAIM_ACTION_REQUEST = 'CLAIM_ACTION_REQUEST'
export const CLAIM_ACTION_SUCCESS = 'CLAIM_ACTION_SUCCESS'
export const CLAIM_ACTION_FAILURE = 'CLAIM_ACTION_FAILURE'

export const UPDATE_CLAIM_FILTERS = 'UPDATE_CLAIM_FILTERS'

export function updateClaimFilters(filters) {
  return {
    type: UPDATE_CLAIM_FILTERS,
    payload: filters
  }
}

export const filtrosConValor = (params = {}) =>
  Object.keys(params).reduce((limpios, clave) => {
    const valor = params[clave]
    const vacio =
      valor === '' ||
      valor === null ||
      valor === undefined ||
      (Array.isArray(valor) && valor.length === 0)
    if (!vacio) limpios[clave] = valor
    return limpios
  }, {})

export function claimList(params = {}) {
  const filtros = filtrosConValor(params)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: withQuery('ticketing/claims/', filtros),
      authenticated: true,
      extra: filtros,
      msg: 'claimList',
      types: [CLAIM_LIST_REQUEST, CLAIM_LIST_SUCCESS, CLAIM_LIST_FAILURE]
    }
  }
}

export function claimDetail(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `ticketing/claims/${idParaRuta(id)}/`,
      authenticated: true,
      msg: 'claimDetail',
      types: [CLAIM_DETAIL_REQUEST, CLAIM_DETAIL_SUCCESS, CLAIM_DETAIL_FAILURE]
    }
  }
}

export function changeClaimStatus(id, { status, comment = '' }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/claims/${idParaRuta(id)}/change-status/`,
      data: { status, comment },
      authenticated: true,
      msg: 'changeClaimStatus',
      types: [CLAIM_ACTION_REQUEST, CLAIM_ACTION_SUCCESS, CLAIM_ACTION_FAILURE]
    }
  }
}

export function answerClaim(id, { provider_response }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/claims/${idParaRuta(id)}/answer-claim/`,
      data: { provider_response },
      authenticated: true,
      msg: 'answerClaim',
      types: [CLAIM_ACTION_REQUEST, CLAIM_ACTION_SUCCESS, CLAIM_ACTION_FAILURE]
    }
  }
}

export function assignClaim(id, { administrator_id, comment = '' }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/claims/${idParaRuta(id)}/assign/`,
      data: { administrator_id, comment },
      authenticated: true,
      msg: 'assignClaim',
      types: [CLAIM_ACTION_REQUEST, CLAIM_ACTION_SUCCESS, CLAIM_ACTION_FAILURE]
    }
  }
}

export function addClaimComment(id, { message, is_internal = true }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/claims/${idParaRuta(id)}/add-comment/`,
      data: { message, is_internal },
      authenticated: true,
      msg: 'addClaimComment',
      types: [CLAIM_ACTION_REQUEST, CLAIM_ACTION_SUCCESS, CLAIM_ACTION_FAILURE]
    }
  }
}
